module.exports = __webpack_public_path__ + "img/header-image-default.4ecc4981.png";